import { createAppReducer } from 'lib/redux/reducerUtils'
import {
  OFFER_COMPARISON_RESTORE_STATE,
  OFFER_COMPARISON_TOGGLE_ENABLED,
  OFFER_COMPARISON_ADD_SELECTION,
  OFFER_COMPARISON_REMOVE_SELECTION,
  OFFER_COMPARISON_TOGGLE_SELECTION,
  OFFER_COMPARISON_CLEAR_ALL,
  OFFER_COMPARISON_REPLACE_SELECTION,
} from 'actions/actionConstants'
import { MAX_COMPARISON_SELECTIONS } from 'constants/offer'

export const initialOfferComparisonState: App.OfferComparisonState = {
  enabled: false,
  selections: [],
}

const offerComparisonReducer = createAppReducer<App.OfferComparisonState>(
  initialOfferComparisonState,
  {
    [OFFER_COMPARISON_RESTORE_STATE]: (_, action) => {
      return action.restoredState
    },
    [OFFER_COMPARISON_TOGGLE_ENABLED]: (state) => {
      return {
        enabled: !state.enabled,
      }
    },
    [OFFER_COMPARISON_ADD_SELECTION]: (state, action) => {
      const isSelected = state.selections.some((s) => s.selectionId === action.selection.selectionId)
      const canAddOffer = state.selections.length < MAX_COMPARISON_SELECTIONS && !isSelected

      if (!canAddOffer) {
        return state
      }

      return {
        selections: [...state.selections, action.selection],
      }
    },
    [OFFER_COMPARISON_REMOVE_SELECTION]: (state, action) => {
      const isSelected = state.selections.some((s) => s.selectionId === action.selectionId)

      if (!isSelected) {
        return state
      }

      return {
        selections: state.selections.filter((s) => s.selectionId !== action.selectionId),
      }
    },
    [OFFER_COMPARISON_TOGGLE_SELECTION]: (state, action) => {
      const isSelected = state.selections.some((s) => s.selectionId === action.selection.selectionId)

      if (isSelected) {
        return {
          selections: state.selections.filter((s) => s.selectionId !== action.selection.selectionId),
        }
      }

      if (!isSelected && state.selections.length < MAX_COMPARISON_SELECTIONS) {
        return {
          selections: [...state.selections, action.selection],
        }
      }

      return state
    },
    [OFFER_COMPARISON_REPLACE_SELECTION]: (state, action) => {
      return {
        selections: state.selections.map((s) => {
          if (s.selectionId === action.selection.selectionId) {
            return action.selection
          } else {
            return s
          }
        }),
      }
    },
    [OFFER_COMPARISON_CLEAR_ALL]: () => {
      return {
        selections: [],
      }
    },
  },
)

export default offerComparisonReducer
